export var ErrorDismissActions;
(function (ErrorDismissActions) {
    ErrorDismissActions["DismissedErrors"] = "DISMISSED";
    ErrorDismissActions["UndismissedErrors"] = "UNDISMISSED";
})(ErrorDismissActions || (ErrorDismissActions = {}));
//# sourceMappingURL=dismissed-error.model.js.map